const {
  track,
  trackAutoEvent,
  hook,
  disableTracking,
  interval,
  experimentId,
  alternativeId,
  projectId,
  appId,
  storeId,
  pageType,
  elementType,
  targetType,
  categories,
  landingId
} = new window.SplitMetrics();

export {
  track,
  trackAutoEvent,
  experimentId,
  alternativeId,
  projectId,
  appId,
  storeId,
  pageType,
  elementType,
  targetType,
  categories,
  landingId,
  hook,
  disableTracking,
  interval
};



// WEBPACK FOOTER //
// ./src/vendor/splitmetrics-track/index.js